import { useQuery } from "@tanstack/react-query";
import { deviceApis } from "../../../../../../shared/apis/device/apis";
import type { IDispatchListParams } from "../../../../../../shared/apis/device/shipment/types";
import { IDispatch } from "../types";

export function useDispatchList(payload: IDispatchListParams) {
  const { data: dispatchList } = useQuery(
    [
      "getDispatchList",
      payload.page,
      payload.channel,
      payload.searchType,
      payload.searchValue,
      payload.deviceTypeCd,
      payload.deviceSubTypeCd,
    ],
    () => deviceApis.shipment.getDispatchList(payload),
    {
      select: (data) => data.data,
    }
  );

  return {
    dispatches: dispatchList?.data as IDispatch[],
    totalCount: dispatchList?.totalCount as number,
  };
}
